export type ConfirmOptions = {
	title: string;
	message?: string;
	confirmLabel?: string;
	cancelLabel?: string;
	/** Styles the confirm button as a destructive action. */
	danger?: boolean;
};

type ConfirmRequest = ConfirmOptions & { resolve: (confirmed: boolean) => void };

// Client-only state: a request holds a resolver, so it stays out of the SSR payload.
const current = shallowRef<ConfirmRequest | null>(null);

/**
 * LeadX replacement for window.confirm. `confirm()` opens the shared dialog
 * mounted in the default layout and resolves true when the user confirms.
 */
export function useConfirm() {
	function confirm(options: ConfirmOptions): Promise<boolean> {
		if (!import.meta.client) return Promise.resolve(false);
		current.value?.resolve(false);
		return new Promise((resolve) => {
			current.value = { ...options, resolve };
		});
	}

	function settle(confirmed: boolean) {
		const request = current.value;
		current.value = null;
		request?.resolve(confirmed);
	}

	return { request: readonly(current), confirm, settle };
}
